export default __webpack_public_path__ + "static/media/greeting2.63b4b1a0.png";